
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/offerings",
      function () {
        return require("private-next-pages/match-booster/offerings.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/offerings"])
      });
    }
  